function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.79.5c1.189 0 2.377.485 3.249 1.453.983 1.002 1.461 2.348 1.461 3.713a5.78 5.78 0 01-1.461 3.86h0l-1.236 1.373-6.865 7.627-6.873-7.823-1.236-1.374C.94 8.342.5 7.04.5 5.74c0-1.3.44-2.602 1.329-3.59C2.703 1.09 3.832.558 4.987.526 6.17.493 7.371.985 8.333 1.962h0l1.6 1.778 1.609-1.787A4.354 4.354 0 0114.79.5z",
  fillRule: "nonzero",
  stroke: "currentcolor",
  fill: "none"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeart;